import { connect } from 'react-redux';
import ToolsComponent from '../../components/tools/ToolsComponent';

function mapStateToProps(state) {
  return {
    general: Object.assign({}, state.tools && state.tools.general),
    shopifyConfigs: state.tools.general.selectedToolDomains.shopifyConfigs || {},
    ordersSearch: state.tools.ordersSearch,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {};
};

const ToolsContainer = connect(mapStateToProps, mapDispatchToProps)(ToolsComponent);

export default ToolsContainer;
